import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Tenant} from "../../../model/tenant";
import {Organization} from "../../../model/organization";

@Component({
  selector: 'app-tenants-confirmation',
  templateUrl: './tenants-confirmation.component.html',
  styleUrls: ['./tenants-confirmation.component.scss']
})
export class TenantsConfirmationComponent implements OnInit {

  @Input() toDelete: Tenant | Organization;
  @Input() typeToDelete: "TENANT" | "ORGANIZATION";
  @Output() visibleChange: EventEmitter<boolean>;
  @Output() delete: EventEmitter<boolean>;
  public dialogVisible: boolean;
  public nameConfirmation: string;

  constructor() {
    this.visibleChange = new EventEmitter<boolean>();
    this.delete = new EventEmitter<boolean>();
  }

  ngOnInit(): void {
  }

  @Input()
  set visible(visible: boolean) {
    this.dialogVisible = visible;
  }

  public saveAndClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.delete.emit(true);
  }

  public closeWithoutSaving(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
